(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  if (!customElements.get('pexh-mega-nav')) {
    customElements.define('pexh-mega-nav', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const { signal } = this.controller;
        const toggle = this.querySelector('.pexh-mega__mobile-toggle');
        this.addEventListener('click', event => {
          if (event.target.closest('.pexh-mega__mobile-toggle')) {
            const open = this.toggleAttribute('data-mobile-open');
            toggle.setAttribute('aria-expanded', String(open));
            if (!open) this.closePanels();
          }
          const summary = event.target.closest('.pexh-mega__trigger');
          if (summary) this.querySelectorAll('details[open]').forEach(item => { if (item !== summary.parentElement) item.open = false; });
          if (event.target.closest('a')) { this.closePanels(); this.removeAttribute('data-mobile-open'); toggle.setAttribute('aria-expanded', 'false'); }
        }, { signal });
        document.addEventListener('click', event => { if (!this.contains(event.target)) this.closePanels(); }, { signal });
        this.addEventListener('keydown', event => {
          if (event.key !== 'Escape') return;
          const open = this.querySelector('details[open]');
          if (open) { open.open = false; open.querySelector('summary').focus(); }
          else if (this.hasAttribute('data-mobile-open')) { this.removeAttribute('data-mobile-open'); toggle.setAttribute('aria-expanded', 'false'); toggle.focus(); }
        }, { signal });
      }
      closePanels() { this.querySelectorAll('details[open]').forEach(item => { item.open = false; }); }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
